import { ChangeDetectorRef, Component, ElementRef, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ServiceModel } from 'src/app/shared/models/service.model';
import { UserServicesService } from 'src/app/layout/services/user-services.service';
import { Subscription, filter } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { AdminTab, AdminbarTabsModel } from './model/adminbar.model';

@Component({
  selector: 'app-admin-bar',
  templateUrl: './admin-bar.component.html',
  styleUrls: ['./admin-bar.component.scss'],
})
export class AdminBarComponent implements OnInit, OnDestroy {
  public servicesIconsPath: string;
  public internalServices: Array<ServiceModel>;
  public internalServicesPerTab: Array<AdminTab> = [
    {
      key: 'services',
      hidden: true,
      name: 'Services',
      services: [],
    },
    {
      key: 'config',
      name: 'Configuration',
      hidden: true,
      services: [
        {
          name: 'Translations',
          description: 'Manage Translations Upload',
          domain: '',
          key: '',
          path: '/translations/private',
          icon: '/assets/img/icons/translate.svg',
          internal: true,
          public_service: false,
          privatename: 'Translations',
          publicname: 'Translations',
        }
      ],
    },
    {
      key: 'aws',
      name: 'AWS',
      hidden: true,
      services: [
        {
          name: 'Status Page',
          description: 'Services Status Page',
          domain: '',
          key: '',
          path: '/aws/private',
          icon: '/assets/img/icons/aws/awsservice.png',
          internal: true,
          public_service: false,
          privatename: 'Status Page',
          publicname: 'Status Page',
        },
      ],
    },
  ];
  private subscriptions: Subscription[] = [];
  public currentServicePath: string;

  constructor(
    private userServicesService: UserServicesService,
    private router: Router,
    private changeDetector: ChangeDetectorRef,
    private eRef: ElementRef
  ) {
    this.servicesIconsPath = this.userServicesService.servicesIconsPath;
  }

  async ngOnInit(): Promise<void> {
    this.internalServices = await this.userServicesService.getUserServices('internal');
    this.internalServices = this.internalServices.map(x => {
      x.path = x.path + '/private';
      let services = [
        'editor2dmaps',
        'catalog',
        'sitesbuilder',
        'mlb-pricescales',
        'seatingdataviewer',
        'amenity-management-system',
        'billing',
      ];
      let config = ['authentication', 'contentdistribution', 'venues', 'contentuploader', 'translations'];
      if (services.indexOf(x.name) > -1) {
        this.internalServicesPerTab[0].services.push(x);
      } else if (config.indexOf(x.name) > -1) {
        this.internalServicesPerTab[1].services.push(x);
      }
      return x;
    });
    this.sortTabs(this.internalServicesPerTab);

    // Get current route when refreshing
    // console.log('Router url: ', this.router.url);
    this.currentServicePath = this.userServicesService.routeToServicePath(this.router.url);
    // console.log('currentServicePath: ' + this.currentServicePath);

    // Get current route changes when navigating
    const routeEvents = this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(event => {
      // console.log('The URL changed to: ' + event['url']);
      this.currentServicePath = this.userServicesService.routeToServicePath(event['url']);
      // console.log(this.currentServicePath);
    });
    this.subscriptions.push(routeEvents);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  private sortTabs(tabs: Array<AdminTab>) {
    tabs = this.sortServicesSubitems(tabs);
    // console.log(tabs);
  }
  private sortServicesSubitems(obj: Array<AdminTab>) {
    obj.map(x => {
      if (x.services) {
        x.services.sort((a, b) => {
          const nameA = a.name.toLowerCase();
          const nameB = b.name.toLowerCase();
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
      }
    });
    return obj;
  }

  public toggleTab(key) {
    // Toggle current
    this.internalServicesPerTab.map(x => {
      // Hidde others
      if (x.key !== key) {
        x.hidden = true;
      } else {
        x.hidden = !x.hidden;
      }
    });
    this.changeDetector.detectChanges();
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.eRef.nativeElement.contains(event.target)) {
      if (event.target.id === 'admin-bar') {
        this.closeAllTabs();
      }
    } else {
      this.closeAllTabs();
    }
  }

  private closeAllTabs() {
    this.internalServicesPerTab.map(t => {
      t.hidden = true;
    });
  }
}
